import { colors } from '../../../constants/colors';

const PRIMARY_COLORS = [
  colors.crunchBerry,
  colors.mrBlueSky,
  colors.purpleHaze,
  colors.shaquilleOteal,
];

/**
 * Note these are super special colors so I'm not putting them in colors.js
 */
const SECONDARY_COLORS = ['#d10b6f', '#3599ce', '#934fa1', '#208b81'];

const getColorIndex = (accountSummary, userProfileId) => {
  if (!accountSummary || !accountSummary.user_profiles) {
    return 0;
  }

  const userProfileIds = accountSummary.user_profiles.map(p => p.user_profile_id);
  return userProfileIds.indexOf(userProfileId);
};

const getPrimaryProfileColor = index => PRIMARY_COLORS[index % 4];
const getSecondaryProfileColor = index => SECONDARY_COLORS[index % 4];

const getProfileColorTheme = (accountSummary, userProfileId) => {
  const colorIndex = getColorIndex(accountSummary, userProfileId);
  return {
    primary: getPrimaryProfileColor(colorIndex),
    secondary: getSecondaryProfileColor(colorIndex),
  };
};

export { getPrimaryProfileColor, getProfileColorTheme };
